import styled from 'styled-components';

import { ReactSelect } from '@main/core-ui';

/**
 * Styled react-select component
 */
export const StyledReactSelect = styled(ReactSelect)`
  .hideable-select__value-container {
    flex-wrap: nowrap;
  }
  .hideable-select__control {
    background-color: ${({ theme }) => theme.colors.white};
  }

  .hideable-select__menu {
    .hideable-select__option {
      &:not(.hideable-select__option--is-disabled) {
        &:hover {
          background-color: ${({ theme }) => theme.colors.gray1};
        }
      }
    }

    .hideable-select__option--is-focused {
      background-color: ${({ theme }) => theme.colors.gray1};
    }

    .hideable-select__option--is-selected {
      background-color: ${({ theme }) => theme.colors.gray4};
    }
  }
`;
